import { createContext } from 'react';

export const AvalancheContext = createContext({
  level: '',
  setLevel: () => {}
});